<ul>
  <li *ngFor="let item of breadcrumbItems">
    <a [routerLink] = item.link>{{item.name}}</a>
    <mat-icon svgIcon="chevron-right"></mat-icon>
  </li>
</ul>
